<template>
  <div class="sova-club" @wheel.prevent>
    <span class="sova-club__close" @click="$emit('close')">
      <svg><use xlink:href="#svg-close"></use></svg>
    </span>

    <div class="sova-club__scroll">
      <SovaClubThanks v-if="result?.complete" :result="result" @close="$emit('close')" />
      <div v-else>
        <SovaClubHeader :result="result" />
        <SovaClubStep :result="result" />
        <SovaClubFooter :result="result" />
      </div>
    </div>
  </div>
</template>

<script setup>
import SovaClubThanks from '@components/SovaClub/SovaClubThanks.vue';
import SovaClubHeader from '@components/SovaClub/SovaClubHeader.vue';
import SovaClubStep from '@components/SovaClub/SovaClubStep.vue';
import SovaClubFooter from '@components/SovaClub/SovaClubFooter.vue';

defineProps(['result']);

// onBeforeUnmount(() => {
//     const clubIdId = result?.id;
//     if (clubIdId) window.sessionStorage.setItem(`isSovaClubModal${clubIdId}WasShown`, true);
// })
</script>

<script>
export default {
  name: 'SovaClub',
};
</script>

<style lang="scss" scoped>
.sova-club {
  display: flex;
  flex-direction: column;
  padding: 46px 16px 32px;
  @include point-md {
    padding: 48px;
  }

  &__close {
    position: absolute;
    cursor: pointer;
    top: 16px;
    right: 16px;

    svg {
      display: block;
      width: 24px;
      height: 24px;
      @include point-md {
        width: 32px;
        height: 32px;
      }
    }
  }

  &__scroll {
    overflow-y: auto;
    height: 100%;
  }
}
</style>
